import { MapPin, Clock, Car, ExternalLink } from "lucide-react";
import { useData } from "@/context/DataContext";
import { resolveUrl } from "@/lib/api";
import { Reveal, SectionHeader } from "@/components/shared/Reveal";

export const SpectatorsSection = () => {
  const { data } = useData();
  const spots = data.spectators || [];
  if (!spots.length) return null;

  return (
    <section data-testid="spectators-section" className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <SectionHeader kicker="Publikplatser" title="Var du ser tävlingen" subtitle="Bra platser för publik längs banan. Fler platser läggs till närmare tävlingen." />
        </Reveal>
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {spots.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.06}>
              <div className="group overflow-hidden rounded-xl border border-white/8 bg-[#14161A] hover-lift hover:border-amber-500/40">
                {s.image && (
                  <div className="relative aspect-video overflow-hidden bg-black">
                    <img src={resolveUrl(s.image)} alt={s.name} loading="lazy" className="aspect-ken h-full w-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#14161A] to-transparent" />
                  </div>
                )}
                <div className="p-5">
                  <h3 className="font-display text-2xl font-bold uppercase text-white">{s.name}</h3>
                  {s.description && <p className="mt-2 text-sm text-white/60">{s.description}</p>}
                  <div className="mt-4 space-y-1.5 text-sm text-white/60">
                    {s.recommended_time && <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-amber-500" />{s.recommended_time}</div>}
                    {s.parking && <div className="flex items-center gap-2"><Car className="w-4 h-4 text-amber-500" />{s.parking}</div>}
                    {s.gps && <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-amber-500" />{s.gps}</div>}
                  </div>
                  {s.maps_url && (
                    <a href={s.maps_url} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 rounded-md bg-amber-500 px-4 py-2 text-xs font-bold uppercase tracking-wide text-black hover:bg-amber-400 transition-colors">
                      <MapPin className="w-3.5 h-3.5" /> Öppna i kartor <ExternalLink className="w-3 h-3" />
                    </a>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
